import { printObject } from '@/lib/utils'
import { IsomorphicLogger } from './logger/types'

export function logError(
	logger: IsomorphicLogger,
	error: unknown,
	message?: string,
	context?: Record<string, any>
) {
  if (error instanceof Error) {
    logger.error(message || 'An error occurred', {
			...context,
      errorMessage: printObject(error.message),
      ...(error.name !== 'Error' && { errorName: error.name }),
      stack: printObject(error.stack),
    })
  }
	else {
    logger.error(message || 'An unknown error occurred', {
			...context,
      error: printObject(error), // Convert to string in case it's not an object
    })
  }
}